import { render, staticRenderFns } from "./resultOnceModal.vue?vue&type=template&id=364e7b1b&scoped=true"
import script from "./resultOnceModal.vue?vue&type=script&lang=js"
export * from "./resultOnceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e7b1b",
  null
  
)

export default component.exports